import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { httpss } from '../utils/host';

export default function PageAdminPageAPI() {
  const [listPages, setListPages] = useState([]);
  const [callback, setCallback] = useState(false);

  const fetPage = async () => {
    await axios.get(`${httpss}/apis_v1/user/list_pages`)
    .then(response => {
      setListPages(response.data);
      // console.log(response.data)
    })
    .catch(error => console.error('Error fetching data:', error));
  }
  
  useEffect(() => {
    fetPage()
  }, [callback]);

  return {
    listPages: [listPages,setListPages],
    callback: [callback, setCallback]
  };
}
